{
  "Accessibility Menu": "Menu prístupnosti",
  "Reset settings": "Obnoviť nastavenia",
  "Close": "Zavrieť",
  "Content Adjustments": "Nastavenia obsahu",
  "Adjust Font Size": "Prispôsobiť veľkosť písma",
  "Highlight Title": "Zvýrazniť nadpis",
  "Highlight Links": "Zvýrazniť odkazy",
  "Readable Font": "Čitateľné písmo",
  "Color Adjustments": "Nastavenia farieb",
  "Dark Contrast": "Tmavý kontrast",
  "Light Contrast": "Svetlý kontrast",
  "High Contrast": "Vysoký kontrast",
  "High Saturation": "Vysoká saturácia",
  "Low Saturation": "Nízka saturácia",
  "Monochrome": "Monochromatické",
  "Tools": "Nástroje",
  "Reading Guide": "Sprievodca čítaním",
  "Stop Animations": "Zastaviť animácie",
  "Big Cursor": "Veľký kurzor",
  "Increase Font Size": "Zväčšiť veľkosť písma",
  "Decrease Font Size": "Zmenšiť veľkosť písma",
  "Letter Spacing": "Rozostup písmen",
  "Line Height": "Výška riadku",
  "Font Weight": "Tlak písma",
  "Dyslexia Font": "Písmo pre dyslexiu",
  "Language": "Jazyk",
  "Open Accessibility Menu": "Otvoriť menu prístupnosti"
}
